import * as React from 'react';
import { Box, Stack, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DescriptionContent } from '../assets/icons';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    tab: {
        minWidth: '240px',
        maxWidth: '240px',
        width: '240px',
        height: '34px',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        backgroundColor: theme.palette.documentViewer.tabBackgroundColor,
        position: 'relative',
        '&.selected': {
            backgroundColor: theme.palette.documentViewer.tabSelectedBackgroundColor,
        },
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.8,
        },
    },
    tabContent: {
        width: 'calc(100% - 32px)',
    },
    contentIco: {
        width: '20px',
        marginRight: '4px',
    },
    tabName: {
        textAlign: 'left',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    tabIconButton: {
        padding: '3px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& svg': {
            width: '20px',
            height: '20px',
        },
    },
    rightBorder: {
        width: '1.5px',
        background: '#626466',
        height: '20px',
    },
}));

export function TabItem(props) {
    const classes = useStyles();
    const [contentIconColor, setContentIconColor] = React.useState(props.iconColor);

    const showMenu = (event) => {
        event.stopPropagation();
        if (props.onMenu) props.onMenu(event);
    };

    const remove = (event) => {
        event.stopPropagation();
        if (props.onClose) props.onClose(props.tabId);
    };

    return (
        <Stack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className={`${classes.tab} ${props.selected ? 'selected' : ''}`}
            onClick={() => props.onSelect(props.tabId)}
        >
            <Stack direction={'row'} justifyContent={'flex-start'} alignItems={'center'} className={classes.tabContent}>
                <IconButton aria-label="close" className={classes.tabIconButton} onClick={remove}>
                    <ClearIcon size={'20px'} />
                </IconButton>
                <DescriptionContent className={classes.contentIco} color={contentIconColor} />
                <Box className={classes.tabName}>{props.name}</Box>
            </Stack>
            <IconButton aria-label="menu" className={classes.tabIconButton} onClick={showMenu}>
                <MoreVertIcon size={'20px'} />
            </IconButton>
            <Box className={classes.rightBorder}></Box>
        </Stack>
    );
}

TabItem.defaultProps = {
    name: '-',
    iconColor: '#FFE485',
};

TabItem.propTypes = {
    tabId: PropTypes.string.isRequired,
    name: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
    iconColor: PropTypes.string,
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
    onMenu: PropTypes.func,
    onClose: PropTypes.func,
};
